import { lazy, Suspense, useCallback } from 'react'

import { useAtomValue } from 'jotai'

import { safeRequestIdleCallback } from '@/shared/lib/safe-request-idle-callback'

import { RunnerState } from '~shared/types'

import { rundownAtom } from '../../../store/rundown.store'
import { runnerStateAtom } from '../../../store/runner.store'
import * as logger from '../../../utils/logger'
import { useNextHardStartCueId } from '../cue/cue-timing.store'
import { useCuesDerived } from '../cue/cue.derived'
import { useCue } from '../cue/cue.hooks'

const FloatingCountdownButton = lazy(
  () =>
    import('../../../components/rundown/timing/FloatingCountdownButton.jsx'),
)

export const NextHardStartCueOverlay = () => {
  const rundown = useAtomValue(rundownAtom)
  const runnerState = useAtomValue(runnerStateAtom)
  const nextHardStartCueId = useNextHardStartCueId()
  const { firstCueId } = useCuesDerived()

  const cue = useCue(nextHardStartCueId)
  const runningCueId = cue?.id

  const handleScrollIntoView = useCallback(() => {
    if (!runningCueId) return

    const cueElement = document.getElementById(runningCueId)

    logger.info('[NextHardStartCueOverlay] scrolling to cue', cueElement)

    safeRequestIdleCallback(
      () => {
        cueElement?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      },
      { timeout: 500 },
    )
    // scrollToVirtualIndex(runningCueIndex)
  }, [runningCueId])

  if (runnerState === RunnerState.ENDED) return null
  if (!nextHardStartCueId) return null
  if (runningCueId === firstCueId) return null

  return (
    <Suspense>
      <FloatingCountdownButton
        cue={cue}
        timezone={rundown?.timezone}
        onScrollTo={handleScrollIntoView}
      />
    </Suspense>
  )
}
